/*
 * Copyright (C) 2009-2025 SonarSource Sàrl
 * All rights reserved
 * mailto:info AT sonarsource DOT com
 */

import { axiosClient } from '~shared/helpers/axios-clients';
import { SandboxInstanceSettings, SandboxProjectSettings } from '../types';

const SANDBOX_ISSUES_PATH = '/api/v2/issues/sandbox-settings';

export function getSandboxInstanceSettings() {
  return axiosClient.get<SandboxInstanceSettings>(SANDBOX_ISSUES_PATH);
}
export function getSandboxProjectSettings(projectKey: string) {
  return axiosClient.get<SandboxProjectSettings>(`${SANDBOX_ISSUES_PATH}/${projectKey}`);
}

export function updateSandboxInstanceSettings(data: Partial<SandboxInstanceSettings>) {
  return axiosClient.patch<SandboxInstanceSettings>(SANDBOX_ISSUES_PATH, data);
}

export function updateSandboxProjectSettings(
  projectKey: string,
  data: Partial<SandboxProjectSettings>,
) {
  return axiosClient.patch<SandboxProjectSettings>(`${SANDBOX_ISSUES_PATH}/${projectKey}`, data);
}
